import { getWaterUsage, getTotalWaterUsage } from 'utils/water-usage';

export const mapDataToClient = (waterUsage) => ({
  coldWater: getWaterUsage(waterUsage.coldWaterUsage),
  hotWater: getWaterUsage(waterUsage.hotWaterUsage),
  totalWater: getTotalWaterUsage(waterUsage),
});
